class Animation {
  constructor() {

    this.progressSection = document.querySelector('.lc-startpage-quote');

    if(this.progressSection) {
      this.bindProgress();
    }

  }

  bindProgress() {
    let leftBorder = document.querySelector('.lc-startpage-quote__border--left');
    let rightBorder = document.querySelector('.lc-startpage-quote__border--right');

    const scroll = () => {
      const offsetTop = this.progressSection.getBoundingClientRect().top + window.scrollY + window.innerHeight/2;
      const distance = window.scrollY - offsetTop + window.innerHeight;
      const totalDistance = this.progressSection.clientHeight/2 - 100;
      const percentage = distance / totalDistance;

      if(percentage > 0) {
        leftBorder.style.transform = `scaleX(${1 - percentage}`;
        rightBorder.style.transform = `scaleX(${1 - percentage}`;
      }
    }

    scroll();
    window.addEventListener('scroll', scroll);
  }
}

export default Animation;
